import { useSettings } from '@capsicum/common';
import { BaseTutorialCard, useTutorial, useTutorialStyles } from '@capsicum/common-web';
import { useEffect } from 'react';

export const useFanShopTutorial = (isLoading: boolean) => {
	const { setup } = useTutorial();
	const { settings } = useSettings();

	const { highlightedAreaStyle, popoverStyles } = useTutorialStyles();

	useEffect(() => {
		if (!isLoading && settings.areTutorialsEnabled.rewardsLobby) {
			setup('rewards-lobby', {
				steps: [
					{
						content: (
							<BaseTutorialCard
								content="rewards.fanshop.tutorials.fanShop.steps.content"
								title="rewards.fanshop.tutorials.fanShop.steps.title"
							/>
						),
						padding: 0,
						position: 'top',
						selector: '[data-tutorial="rewardsLobbyTutorial"]',
						stepInteraction: false,
						styles: {
							highlightedArea: highlightedAreaStyle({ disableInteraction: true }),
							popover: base => ({
								...base,
								...popoverStyles()?.({ ...base, top: -32 })
							})
						}
					}
				]
			});
		}
	}, [highlightedAreaStyle, setup, isLoading, popoverStyles, settings]);
};
